import { EventSearchForm, FieldNameEnum } from '@mark43/cad-api';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { formatMonthDayHoursMinutes } from '../common/helpers/utils';
import { FilterSummary } from '../search-windows/filter-summary';
import { FiltersSummary } from '../search-windows/filters-summary';

export function EventInformationFiltersSummary({
    eventSearchForm,
}: {
    eventSearchForm: EventSearchForm;
}) {
    const { fieldDisplayNameByFieldName } = useBootstrapState();
    const renDisplayName =
        fieldDisplayNameByFieldName[FieldNameEnum.AGENCY_EVENT_REPORTING_EVENT_NUMBER.name];
    return (
        <FiltersSummary title="Event Information">
            <FilterSummary
                label="Event #s"
                stringValues={eventSearchForm.eventNumbers.map(
                    (eventNumber) => eventNumber.eventNumber
                )}
            />
            <FilterSummary
                label={`${renDisplayName}s`}
                stringValues={eventSearchForm.reportingEventNumbers.map(
                    (ren) => ren.reportingEventNumber
                )}
            />
            <FilterSummary label="Dispatched" option={eventSearchForm.dispatched} />
            <FilterSummary
                label={`${renDisplayName} Generated`}
                option={eventSearchForm.reportingEventNumberGenerated}
            />
            <FilterSummary label="Call For Service" options={eventSearchForm.callForServices} />
            <FilterSummary label="Labels" options={eventSearchForm.eventLabels} />
            <FilterSummary label="Priority Level" options={eventSearchForm.priorities} />
            <FilterSummary label="Agency" options={eventSearchForm.agencyProfiles} />
            <FilterSummary
                label="Assisting Agencies"
                options={eventSearchForm.assistingAgencyProfiles}
            />
            <FilterSummary label="Agency Type" option={eventSearchForm.agencyType} />
            <FilterSummary label="Dispatch Area" options={eventSearchForm.dispatchAreas} />
            <FilterSummary label="Radio Channels" options={eventSearchForm.radioChannels} />
            <FilterSummary label="Hospitals" options={eventSearchForm.hospitals} />
            <FilterSummary label="Call Origin" options={eventSearchForm.eventOrigins} />
            <FilterSummary label="Call Type" option={eventSearchForm.eventQueue} />
            <FilterSummary label="Dispatcher" options={eventSearchForm.dispatchers} />
            <FilterSummary label="Call Taker" options={eventSearchForm.callTakers} />
            <FilterSummary
                label="Narrative Keywords"
                stringValue={eventSearchForm.narrativeKeywords}
            />
            <FilterSummary label="Time Range" option={eventSearchForm.timeRangeOption} />
            <FilterSummary
                label="Date Range Start"
                stringValue={
                    eventSearchForm.dateRange?.start
                        ? formatMonthDayHoursMinutes(eventSearchForm.dateRange.start)
                        : undefined
                }
            />
            <FilterSummary
                label="Date Range End"
                stringValue={
                    eventSearchForm.dateRange?.end
                        ? formatMonthDayHoursMinutes(eventSearchForm.dateRange.end)
                        : undefined
                }
            />
            <FilterSummary
                label="Primary Disposition"
                options={eventSearchForm.primaryDispositions}
            />
            <FilterSummary
                label="Secondary Dispositions"
                options={eventSearchForm.secondaryDispositions}
            />
            <FilterSummary label="Self Initiated" stringValue={eventSearchForm.selfInitiated} />
            <FilterSummary label="Primary Unit" options={eventSearchForm.primaryUnits} />
            <FilterSummary label="Involved Units" options={eventSearchForm.involvedUnits} />
            <FilterSummary label="Primary Officer" options={eventSearchForm.primaryOfficers} />
            <FilterSummary label="Involved Officers" options={eventSearchForm.involvedOfficers} />
        </FiltersSummary>
    );
}
